import React from 'react';
import { CellText } from '@opendate-app/setlist';
import ReportingGiftCardsReportPage, { formatCents, centsKpiCard, countKpiCard } from './ReportingGiftCardsReportPage';
import {
  GIFT_CARD_LEDGER_COLUMNS, SORT_TYPES, defaultVisibleColumns, defaultHiddenColumns,
} from '../constants/giftCardsColumnsConfig';

const entryTime = (value) => new Date(value).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });

const LEDGER_CONFIG = {
  pageTitle: 'Gift Card Ledger',
  pageSubtitle: 'Changes to your gift card balances in the selected range, for accounting. A card\'s unused balance posts as Expired on the day it expires, and as Expiry reversed if a refund later reopens the card. Export it to reconcile with your books.',
  sidebarKey: 'gift_cards_ledger',
  defaultPreset: 'this_month',
  dateModeOptions: [{ key: 'order_date', label: 'Entry Date' }],
  defaultSortRules: [{ field: 'created_at', direction: 'desc' }],

  columns: GIFT_CARD_LEDGER_COLUMNS,
  sortTypes: SORT_TYPES,
  getDefaultVisibleColumns: defaultVisibleColumns(GIFT_CARD_LEDGER_COLUMNS),
  getDefaultHiddenColumns: defaultHiddenColumns(GIFT_CARD_LEDGER_COLUMNS),
  localStorageKey: (teamId) => `reportingGiftCardsLedgerColumns_${teamId}`,
  firstColumnId: 'created_at',

  detailErrorMessage: 'Failed to load the gift card ledger.',
  detailTableTitle: 'Ledger Entries',
  emptyMessage: 'No gift card activity in this range.',
  searchPlaceholder: 'Search card ending, order # or note...',
  paginationLabel: 'entries',
  itemLabel: (count) => `entr${count !== 1 ? 'ies' : 'y'}`,

  buildKpiCards: (current, prior) => [
    countKpiCard('Entries', 'entries', current, prior),
    centsKpiCard('Net Change', 'net_change_cents', current, prior),
    centsKpiCard('Issued', 'issued_cents', current, prior),
    centsKpiCard('Redeemed', 'redeemed_cents', current, prior),
    centsKpiCard('Credited Back', 'credited_cents', current, prior),
    centsKpiCard('Adjusted', 'adjusted_cents', current, prior),
    centsKpiCard('Voided', 'voided_cents', current, prior),
    centsKpiCard('Expired', 'expired_cents', current, prior),
  ],

  renderCellValue: (col, row, { formatEventDate }) => {
    switch (col.id) {
      case 'created_at': return <CellText primary={formatEventDate(row.created_at)} supporting={entryTime(row.created_at)} />;
      case 'code_last4': return `…${row.code_last4}`;
      case 'product_name': return row.product_name;
      case 'kind': return row.kind_label;
      case 'amount_cents': return formatCents(row.amount_cents);
      case 'balance_after_cents': return formatCents(row.balance_after_cents);
      case 'venue_name': return row.venue_name || '—';
      case 'order_id': return row.order_id || '—';
      case 'note': return row.note || '—';
      default: return '—';
    }
  },
};

function ReportingGiftCardsLedgerPage(props) {
  return (
    <ReportingGiftCardsReportPage
      {...props}
      report="ledger"
      filterIds={['gift_card_product_id', 'kind']}
      config={LEDGER_CONFIG}
    />
  );
}

export default ReportingGiftCardsLedgerPage;
